import { render, staticRenderFns } from "./iWantRepair.vue?vue&type=template&id=0a14504a&scoped=true&"
import script from "./iWantRepair.vue?vue&type=script&lang=js&"
export * from "./iWantRepair.vue?vue&type=script&lang=js&"
import style0 from "./iWantRepair.vue?vue&type=style&index=0&id=0a14504a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a14504a",
  null
  
)

export default component.exports